// @ts-check

// Vendor imports
const _ = require('lodash')
const Bluebird = require('bluebird')

/**
 * @type {Object} Branch SDK
 * @prop {function} setIdentity
 */
// @ts-ignore Assume that branch exists on the window object
const branchSdk = typeof window === 'object' ? window.branch : null

/**
 * @type {Object}
 * @prop {string} identity_id Unique string that identifies the user
 */
let branchIdentity

/**
 * @param {Object} user
 * @param {string|number} user.id
 * @param {boolean} user.loggedIn
 * @see https://docs.branch.io/web/integrate/#track-users
 */
async function identifyUser(user) {
  if (
    // The Branch SDK is sometimes blocked by the user-agent;
    // Additionally, we only load Branch on certain pages.
    !branchSdk ||
    // Logged-out users have a randomly-generated anonymous ID
    !user.loggedIn
  ) {
    return
  }

  branchIdentity = await Bluebird.fromCallback(callback => {
    branchSdk.setIdentity(String(user.id), callback)
  })
}

/**
 * Used by the `branch_params` field of `client_session` data
 * @returns {Object} Business Event Branch parameters
 * @see https://docs.branch.io/web/integrate/#initialize-branch-features
 */
function getBusinessEventParams() {
  return {
    ..._.get(window, 'branchInitData.data_parsed', {}),
    'branch_identity_id': (
      _.get(branchIdentity, 'identity_id') ||
      _.get(window, 'branchInitData.identity')
    )
  }
}

module.exports = {
  identifyUser,
  getBusinessEventParams
}
